/* src/app/core/authentication/login/login.component.scss */
.fct-login {
  display: flex;
  height: 100vh;
  font-family:
    "Inter Tight",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  background: #1d2530;
  overflow: hidden;
}
.fct-brand {
  flex: 0 0 45%;
  background: #1d2530;
  background-image:
    radial-gradient(
      circle,
      rgba(255, 255, 255, 0.055) 1px,
      transparent 1px);
  background-size: 28px 28px;
  display: flex;
  align-items: center;
  align-items: safe center;
  justify-content: center;
  padding: 56px 52px;
  position: relative;
  isolation: isolate;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid rgba(227, 253, 100, 0.08);
}
.fct-brand::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background:
    radial-gradient(
      520px circle at var(--mx, 72%) var(--my, 28%),
      rgba(227, 253, 100, 0.075),
      transparent 62%);
  transition: background 0.2s;
}
.fct-brand::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background:
    linear-gradient(
      90deg,
      transparent 0%,
      rgba(227, 253, 100, 0.6) 40%,
      rgba(227, 253, 100, 0.6) 60%,
      transparent 100%);
}
@media (max-height: 760px) {
  .fct-brand {
    padding: 32px 44px;
  }
}
@media (max-width: 860px) {
  .fct-brand {
    display: none;
  }
}
.fct-aurora {
  position: absolute;
  inset: 0;
  z-index: -2;
  overflow: hidden;
  pointer-events: none;
}
.fct-aurora__blob {
  position: absolute;
  border-radius: 50%;
  will-change: transform;
}
.fct-aurora__blob--a {
  width: 620px;
  height: 620px;
  top: -260px;
  left: -220px;
  background:
    radial-gradient(
      circle,
      rgba(227, 253, 100, 0.13) 0%,
      rgba(227, 253, 100, 0) 68%);
  animation: fct-drift-a 22s ease-in-out infinite alternate;
}
.fct-aurora__blob--b {
  width: 540px;
  height: 540px;
  bottom: -240px;
  right: -200px;
  background:
    radial-gradient(
      circle,
      rgba(244, 254, 158, 0.08) 0%,
      rgba(244, 254, 158, 0) 70%);
  animation: fct-drift-b 26s ease-in-out infinite alternate;
}
@keyframes fct-drift-a {
  from {
    transform: translate3d(0, 0, 0) scale(1);
  }
  to {
    transform: translate3d(120px, 90px, 0) scale(1.15);
  }
}
@keyframes fct-drift-b {
  from {
    transform: translate3d(0, 0, 0) scale(1.05);
  }
  to {
    transform: translate3d(-110px, -70px, 0) scale(0.92);
  }
}
.fct-brand__dots-hi {
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background-image:
    radial-gradient(
      circle,
      rgba(227, 253, 100, 0.55) 1px,
      transparent 1.4px);
  background-size: 28px 28px;
  -webkit-mask-image:
    radial-gradient(
      200px circle at var(--mx, 72%) var(--my, 28%),
      #000 0%,
      transparent 72%);
  mask-image:
    radial-gradient(
      200px circle at var(--mx, 72%) var(--my, 28%),
      #000 0%,
      transparent 72%);
  opacity: var(--spot, 0.45);
  transition: opacity 0.4s ease;
}
.fct-brand__inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
@media (max-height: 760px) {
  .fct-brand__inner {
    gap: 18px;
  }
}
@media (max-height: 960px) {
  .fct-brand {
    padding-top: 36px;
    padding-bottom: 36px;
  }
  .fct-brand__inner {
    gap: 22px;
  }
  .fct-widget__chart {
    height: 34px;
  }
}
@media (max-height: 760px) {
  .fct-brand {
    padding-top: 28px;
    padding-bottom: 28px;
  }
  .fct-brand__inner {
    gap: 16px;
  }
  .fct-widget__chart {
    height: 28px;
  }
}
.fct-brand__top {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.fct-brand__logo {
  height: 70px;
  width: auto;
  max-width: 180px;
  object-fit: contain;
  align-self: flex-start;
  opacity: 0.92;
  animation: fct-up 0.6s ease both;
}
.fct-brand__label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.14em;
  color: rgba(255, 255, 255, 0.28);
  text-transform: uppercase;
  animation: fct-up 0.6s ease 0.04s both;
}
.fct-brand__copy {
  animation: fct-up 0.6s ease 0.08s both;
}
.fct-brand__headline {
  font-family:
    "Bricolage Grotesque",
    "Inter Tight",
    sans-serif;
  font-size: 38px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.94);
  line-height: 1.14;
  letter-spacing: -0.035em;
  margin: 0 0 14px;
}
.fct-word {
  display: inline-block;
}
.fct-hl {
  position: relative;
  display: inline-block;
  color: #e3fd64;
  white-space: nowrap;
}
.fct-hl__swash {
  position: absolute;
  left: 0;
  bottom: -9px;
  width: 100%;
  height: 14px;
  overflow: visible;
}
.fct-hl__swash path {
  fill: none;
  stroke: #e3fd64;
  stroke-width: 3;
  stroke-linecap: round;
  opacity: 0.85;
}
.fct-brand__tagline {
  font-size: 14.5px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.42);
  line-height: 1.65;
  margin: 0;
}
.fct-network {
  width: 100%;
  height: auto;
  overflow: visible;
  translate: calc(var(--px, 0) * -6px) calc(var(--py, 0) * -4px);
  transition: translate 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}
@media (max-height: 860px) {
  .fct-network {
    display: none;
  }
}
.fct-network__mesh {
  fill: none;
  stroke: rgba(227, 253, 100, 0.14);
  stroke-width: 1;
  stroke-dasharray: 300;
  stroke-dashoffset: 300;
}
.fct-network__line {
  fill: none;
  stroke: rgba(227, 253, 100, 0.3);
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-dasharray: 300;
  stroke-dashoffset: 300;
}
.fct-network__ping {
  fill: none;
  stroke: #e3fd64;
  stroke-width: 1.5;
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
}
.fct-network__orbit {
  fill: none;
  stroke: rgba(227, 253, 100, 0.4);
  stroke-width: 1;
  stroke-dasharray: 2 6;
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
}
.fct-network__hub {
  fill: #e3fd64;
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
  filter: drop-shadow(0 0 8px rgba(227, 253, 100, 0.55));
}
.fct-network__node {
  fill: #29323f;
  stroke: #e3fd64;
  stroke-width: 1.5;
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
}
.fct-network__pulse {
  fill: #f4fe9e;
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
}
.fct-network__label {
  fill: rgba(255, 255, 255, 0.4);
  font-size: 8.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-anchor: middle;
  font-family: "Inter Tight", sans-serif;
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .fct-network__line,
  .fct-network__mesh {
    stroke-dashoffset: 0;
  }
  .fct-network__hub,
  .fct-network__node,
  .fct-network__label,
  .fct-network__orbit {
    opacity: 1;
  }
}
.fct-widget-wrap {
  position: relative;
  translate: calc(var(--px, 0) * 10px) calc(var(--py, 0) * 8px);
  transition: translate 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}
@property --fct-angle { syntax: "<angle>"; initial-value: 0deg; inherits: false; }
.fct-widget {
  position: relative;
  background:
    linear-gradient(
      160deg,
      rgba(41, 50, 63, 0.92) 0%,
      rgba(33, 41, 53, 0.92) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 20px 22px;
  box-shadow: 0 24px 60px -24px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(0, 0, 0, 0.12);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  animation: fct-up 0.6s ease 0.14s both;
}
.fct-widget::before {
  content: "";
  position: absolute;
  inset: -1px;
  border-radius: inherit;
  padding: 1px;
  pointer-events: none;
  background:
    conic-gradient(
      from var(--fct-angle),
      transparent 0deg,
      transparent 250deg,
      rgba(227, 253, 100, 0.75) 300deg,
      transparent 340deg,
      transparent 360deg);
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  mask-composite: exclude;
  animation: fct-spin 7s linear infinite;
}
@keyframes fct-spin {
  to {
    --fct-angle: 360deg;
  }
}
.fct-widget__chart {
  display: block;
  width: 100%;
  height: 44px;
  margin: -4px 0 10px;
  overflow: visible;
}
.fct-widget__chart-area {
  fill: url(#fct-chart-fill);
  stroke: none;
}
.fct-widget__chart-line {
  fill: none;
  stroke: #e3fd64;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
}
.fct-widget__chart-dot {
  fill: #e3fd64;
  filter: drop-shadow(0 0 6px rgba(227, 253, 100, 0.8));
}
.fct-widget__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.fct-widget__period {
  font-size: 11.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.38);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.fct-widget__badge {
  font-size: 10.5px;
  font-weight: 600;
  color: #16a34a;
  background: rgba(22, 163, 74, 0.12);
  padding: 3px 8px;
  border-radius: 20px;
}
.fct-widget__rows {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.fct-widget__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.fct-widget__row:last-child {
  border-bottom: none;
}
.fct-widget__row--total {
  padding-top: 12px;
  margin-top: 4px;
  border-bottom: none;
  border-top: 1px solid rgba(255, 255, 255, 0.08) !important;
}
.fct-widget__concept {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.48);
}
.fct-widget__amount {
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: rgba(255, 255, 255, 0.82);
}
.fct-widget__amount--pos {
  color: #4ade80;
}
.fct-widget__amount--neg {
  color: #f87171;
}
.fct-widget__row--total .fct-widget__concept {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.75);
}
.fct-widget__row--total .fct-widget__amount {
  font-size: 15px;
  font-weight: 700;
  color: #e3fd64;
}
.fct-widget__progress {
  margin-top: 14px;
  height: 3px;
  background: rgba(255, 255, 255, 0.07);
  border-radius: 999px;
  overflow: hidden;
}
.fct-widget__bar {
  height: 100%;
  background:
    linear-gradient(
      90deg,
      #e3fd64 0%,
      #f4fe9e 100%);
  border-radius: 999px;
  transform-origin: left;
  animation: fct-bar 1.1s cubic-bezier(0.16, 1, 0.3, 1) 0.7s both;
}
@keyframes fct-bar {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
.fct-widget__note {
  margin: 10px 0 0;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.28);
  display: flex;
  align-items: center;
  gap: 6px;
}
.fct-widget__dot {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e3fd64;
  flex-shrink: 0;
  animation: fct-blink 2s ease-in-out infinite;
}
@keyframes fct-blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}
.fct-toasts {
  position: absolute;
  top: -38px;
  right: -40px;
  width: 214px;
  height: 52px;
  pointer-events: none;
  translate: calc(var(--px, 0) * 8px) calc(var(--py, 0) * 6px);
  transition: translate 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}
@media (max-width: 1100px) {
  .fct-toasts {
    right: -12px;
    top: -44px;
  }
}
.fct-toast {
  position: absolute;
  inset: 0 0 auto auto;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 14px 34px -10px rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(15, 23, 42, 0.04);
  opacity: 0;
}
.fct-toast:first-child {
  opacity: 1;
}
.fct-toast__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  flex-shrink: 0;
  background: #1d2530;
  color: #e3fd64;
}
.fct-toast__icon svg {
  width: 15px;
  height: 15px;
}
.fct-toast__icon--ok {
  background: #e3fd64;
  color: #1d2530;
}
.fct-toast__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.25;
}
.fct-toast__text strong {
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fct-toast__text small {
  font-size: 10.5px;
  color: #6b7280;
  white-space: nowrap;
}
.fct-trust {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  animation: fct-up 0.6s ease 0.2s both;
}
.fct-trust__chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px 4px 7px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.45);
}
.fct-trust__chip svg {
  width: 12px;
  height: 12px;
  color: #e3fd64;
}
.fct-trust__sep {
  opacity: 0.3;
}
.fct-form {
  flex: 1;
  background: #f6f8f1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 56px;
  overflow-y: auto;
  position: relative;
  isolation: isolate;
}
.fct-form::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background:
    radial-gradient(
      640px circle at 100% 0%,
      rgba(227, 253, 100, 0.42),
      transparent 62%),
    radial-gradient(
      520px circle at 0% 100%,
      rgba(227, 253, 100, 0.18),
      transparent 66%),
    radial-gradient(
      700px circle at 55% 55%,
      rgba(255, 255, 255, 0.9),
      transparent 70%);
}
.fct-form::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background-image:
    radial-gradient(
      circle,
      rgba(29, 37, 48, 0.1) 1px,
      transparent 1.4px);
  background-size: 24px 24px;
  -webkit-mask-image:
    radial-gradient(
      ellipse 80% 70% at 50% 50%,
      transparent 30%,
      #000 100%);
  mask-image:
    radial-gradient(
      ellipse 80% 70% at 50% 50%,
      transparent 30%,
      #000 100%);
}
@media (max-width: 860px) {
  .fct-form {
    background: #1d2530;
    padding: 40px 24px;
  }
  .fct-form::before {
    background:
      radial-gradient(
        480px circle at 100% 0%,
        rgba(227, 253, 100, 0.12),
        transparent 60%);
  }
  .fct-form::after {
    display: none;
  }
  .fct-form .fct-form__bg {
    display: none;
  }
}
@media (max-width: 480px) {
  .fct-form {
    padding: 32px 20px;
  }
}
.fct-form__inner {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  gap: 0;
  animation: fct-up 0.55s ease 0.1s both;
}
@media (min-width: 861px) {
  .fct-form__inner {
    position: relative;
    max-width: 432px;
    padding: 36px 38px 28px;
    background: rgba(255, 255, 255, 0.86);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(15, 23, 42, 0.06);
    border-radius: 20px;
    box-shadow:
      0 1px 2px rgba(15, 23, 42, 0.04),
      0 12px 24px -12px rgba(29, 37, 48, 0.12),
      0 40px 80px -36px rgba(29, 37, 48, 0.35);
  }
  .fct-form__inner::before {
    content: "";
    position: absolute;
    top: -1px;
    left: 28px;
    right: 28px;
    height: 2px;
    border-radius: 2px;
    background:
      linear-gradient(
        90deg,
        transparent,
        #e3fd64 30%,
        #c8e63a 50%,
        #e3fd64 70%,
        transparent);
  }
}
.fct-hint {
  margin: 10px 0 0;
  text-align: center;
  font-size: 11.5px;
  color: #9ca3af;
}
.fct-hint kbd {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 5px;
  border: 1px solid #e5e7eb;
  border-bottom-width: 2px;
  background: #f9fafb;
  font-family: "Inter Tight", sans-serif;
  font-size: 10.5px;
  font-weight: 600;
  color: #4b5563;
}
@media (max-width: 860px) {
  .fct-hint {
    color: rgba(255, 255, 255, 0.3);
  }
  .fct-hint kbd {
    border-color: rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.6);
  }
}
.fct-form__bg {
  position: absolute;
  inset: 0;
  z-index: -1;
  overflow: hidden;
  pointer-events: none;
}
.fct-form__orbits {
  position: absolute;
  left: -170px;
  bottom: -170px;
  width: 440px;
  height: 440px;
  z-index: -1;
  pointer-events: none;
  animation: fct-orbit-spin 80s linear infinite;
}
.fct-form__orbit {
  fill: none;
  stroke: rgba(29, 37, 48, 0.1);
  stroke-width: 1;
  stroke-dasharray: 2 7;
}
.fct-form__orbit--mid {
  stroke: rgba(77, 122, 0, 0.22);
  stroke-dasharray: none;
}
.fct-form__orbit-node {
  fill: #f6f8f1;
  stroke: rgba(77, 122, 0, 0.45);
  stroke-width: 1.5;
}
.fct-form__orbit-node--solid {
  fill: #e3fd64;
  stroke: rgba(77, 122, 0, 0.35);
}
@keyframes fct-orbit-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-height: 640px) {
  .fct-form__bg {
    display: none;
  }
}
.fct-mobile-logo {
  display: none;
  height: 28px;
  width: auto;
  max-width: 140px;
  object-fit: contain;
  align-self: flex-start;
  margin-bottom: 32px;
}
@media (max-width: 860px) {
  .fct-mobile-logo {
    display: block;
  }
}
.fct-form__header {
  margin-bottom: 20px;
}
.fct-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
  padding: 4px 10px 4px 8px;
  border-radius: 999px;
  background: rgba(227, 253, 100, 0.28);
  border: 1px solid rgba(77, 122, 0, 0.18);
  font-size: 11.5px;
  font-weight: 600;
  color: #3d6100;
}
.fct-eyebrow svg {
  width: 13px;
  height: 13px;
}
@media (max-width: 860px) {
  .fct-eyebrow {
    background: rgba(227, 253, 100, 0.1);
    border-color: rgba(227, 253, 100, 0.2);
    color: #e3fd64;
  }
}
.fct-form__title {
  margin: 0 0 6px;
  font-family:
    "Bricolage Grotesque",
    "Inter Tight",
    sans-serif;
  font-size: 30px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.025em;
  line-height: 1.2;
}
@media (max-width: 860px) {
  .fct-form__title {
    color: rgba(255, 255, 255, 0.92);
  }
}
.fct-form__sub {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}
@media (max-width: 860px) {
  .fct-form__sub {
    color: rgba(255, 255, 255, 0.42);
  }
}
.fct-alert {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 11px 14px;
  border-radius: 8px;
  background: #fff1f2;
  border: 1px solid rgba(220, 38, 38, 0.18);
  color: #dc2626;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 20px;
  animation: fct-shake 0.35s ease;
}
.fct-alert__icon {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  margin-top: 1px;
  color: #dc2626;
}
@media (max-width: 860px) {
  .fct-alert {
    background: rgba(220, 38, 38, 0.1);
    border-color: rgba(220, 38, 38, 0.25);
    color: #fca5a5;
  }
}
@keyframes fct-shake {
  0% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-5px);
  }
  40% {
    transform: translateX(4px);
  }
  60% {
    transform: translateX(-3px);
  }
  80% {
    transform: translateX(2px);
  }
  100% {
    transform: translateX(0);
  }
}
.fct-fields {
  display: flex;
  flex-direction: column;
  margin-bottom: 26px;
}
.fct-field-group {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.fct-label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  display: block;
}
@media (max-width: 860px) {
  .fct-label {
    color: rgba(255, 255, 255, 0.7);
  }
}
.fct-field-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fct-mat-field {
  width: 100%;
}
.fct-mat-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.fct-mat-field ::ng-deep .mdc-notched-outline__leading,
.fct-mat-field ::ng-deep .mdc-notched-outline__notch,
.fct-mat-field ::ng-deep .mdc-notched-outline__trailing {
  border-color: #e5e7eb !important;
}
.fct-mat-field ::ng-deep .mdc-text-field--outlined:hover:not(.mdc-text-field--focused):not(.mdc-text-field--disabled) .mdc-notched-outline__leading,
.fct-mat-field ::ng-deep .mdc-text-field--outlined:hover:not(.mdc-text-field--focused):not(.mdc-text-field--disabled) .mdc-notched-outline__notch,
.fct-mat-field ::ng-deep .mdc-text-field--outlined:hover:not(.mdc-text-field--focused):not(.mdc-text-field--disabled) .mdc-notched-outline__trailing {
  border-color: #9ca3af !important;
}
.fct-mat-field ::ng-deep .mdc-text-field--focused .mdc-notched-outline__leading,
.fct-mat-field ::ng-deep .mdc-text-field--focused .mdc-notched-outline__notch,
.fct-mat-field ::ng-deep .mdc-text-field--focused .mdc-notched-outline__trailing {
  border-color: #e3fd64 !important;
  border-width: 1.5px;
  box-shadow: 0 0 0 3px rgba(227, 253, 100, 0.28);
}
.fct-mat-field ::ng-deep .mat-mdc-floating-label {
  color: #6b7280;
  font-family: "Inter Tight", sans-serif;
}
.fct-mat-field ::ng-deep .mdc-text-field--focused .mat-mdc-floating-label {
  color: #e3fd64 !important;
}
.fct-mat-field ::ng-deep .mat-mdc-input-element {
  color: #0f172a;
  font-family: "Inter Tight", sans-serif;
  font-size: 14.5px;
}
.fct-mat-field ::ng-deep .mdc-text-field--outlined .mdc-notched-outline {
  height: 42px;
}
.fct-mat-field ::ng-deep .mat-mdc-form-field-infix {
  padding: 9px 0;
  min-height: 42px;
}
.fct-mat-field ::ng-deep .mat-mdc-text-field-wrapper {
  height: 42px;
}
.fct-mat-field ::ng-deep .mat-mdc-form-field-flex {
  height: 42px;
  align-items: center;
}
.fct-mat-field ::ng-deep .mat-mdc-form-field-text-suffix {
  display: flex;
  align-items: center;
  align-self: center;
}
@media (max-width: 860px) {
  .fct-mat-field ::ng-deep .mdc-notched-outline__leading,
  .fct-mat-field ::ng-deep .mdc-notched-outline__notch,
  .fct-mat-field ::ng-deep .mdc-notched-outline__trailing {
    border-color: rgba(255, 255, 255, 0.12) !important;
  }
  .fct-mat-field ::ng-deep .mat-mdc-input-element {
    color: rgba(255, 255, 255, 0.9) !important;
  }
  .fct-mat-field ::ng-deep .mat-mdc-floating-label {
    color: rgba(255, 255, 255, 0.45) !important;
  }
  .fct-mat-field ::ng-deep .mat-mdc-input-element:-webkit-autofill,
  .fct-mat-field ::ng-deep .mat-mdc-input-element:-webkit-autofill:hover,
  .fct-mat-field ::ng-deep .mat-mdc-input-element:-webkit-autofill:focus,
  .fct-mat-field ::ng-deep .mat-mdc-input-element:-webkit-autofill:active {
    -webkit-text-fill-color: rgba(255, 255, 255, 0.9) !important;
    -webkit-box-shadow: 0 0 0 1000px #1d2530 inset !important;
    box-shadow: 0 0 0 1000px #1d2530 inset !important;
    caret-color: rgba(255, 255, 255, 0.9);
    transition: background-color 9999s ease-in-out 0s;
  }
}
@media (min-width: 861px) {
  .fct-mat-field ::ng-deep .mat-mdc-input-element:-webkit-autofill,
  .fct-mat-field ::ng-deep .mat-mdc-input-element:-webkit-autofill:hover,
  .fct-mat-field ::ng-deep .mat-mdc-input-element:-webkit-autofill:focus,
  .fct-mat-field ::ng-deep .mat-mdc-input-element:-webkit-autofill:active {
    -webkit-text-fill-color: #0f172a !important;
    -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
    box-shadow: 0 0 0 1000px #ffffff inset !important;
    caret-color: #0f172a;
    transition: background-color 9999s ease-in-out 0s;
  }
}
.fct-pw-toggle {
  color: #9ca3af !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  transition: color 0.15s;
}
.fct-pw-toggle:hover {
  color: #e3fd64 !important;
}
.fct-pw-toggle .mat-icon {
  font-size: 20px;
  line-height: 20px;
  width: 20px;
  height: 20px;
}
@media (max-width: 860px) {
  .fct-pw-toggle {
    color: rgba(255, 255, 255, 0.4) !important;
  }
  .fct-pw-toggle:hover {
    color: #e3fd64 !important;
  }
}
.fct-link {
  font-size: 12.5px;
  font-weight: 500;
  color: #6b7280;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: "Inter Tight", sans-serif;
  text-decoration: none;
  transition: color 0.15s;
}
.fct-link:hover {
  color: #4d7a00;
}
.fct-link--accent {
  color: #4d7a00;
  font-weight: 600;
}
.fct-link--accent:hover {
  color: #3d6100;
}
@media (max-width: 860px) {
  .fct-link {
    color: rgba(255, 255, 255, 0.45);
  }
  .fct-link:hover {
    color: #e3fd64;
  }
}
.fct-remember {
  display: flex;
  align-items: center;
  gap: 9px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.fct-check__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.fct-check__input:checked + .fct-check__box {
  background: #e3fd64;
  border-color: #e3fd64;
}
.fct-check__input:checked + .fct-check__box::after {
  opacity: 1;
  transform: scale(1) rotate(-5deg);
}
.fct-check__input:focus-visible + .fct-check__box {
  outline: 2px solid #e3fd64;
  outline-offset: 2px;
}
.fct-check__box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1.5px solid #d1d5db;
  background: #ffffff;
  flex-shrink: 0;
  transition: background 0.15s, border-color 0.15s;
}
.fct-check__box::after {
  content: "";
  display: block;
  width: 9px;
  height: 6px;
  border-left: 1.8px solid #1d2530;
  border-bottom: 1.8px solid #1d2530;
  transform: scale(0) rotate(-5deg);
  transform-origin: center;
  opacity: 0;
  transition: opacity 0.12s, transform 0.12s;
  margin-top: -2px;
}
@media (max-width: 860px) {
  .fct-check__box {
    border-color: rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.05);
  }
}
.fct-check__text {
  font-size: 13px;
  color: #4b5563;
}
@media (max-width: 860px) {
  .fct-check__text {
    color: rgba(255, 255, 255, 0.55);
  }
}
.fct-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: 100%;
  height: 46px;
  background: #e3fd64;
  color: rgba(0, 0, 0, 0.85);
  border: none;
  border-radius: 8px;
  font-size: 14.5px;
  font-weight: 600;
  font-family: "Inter Tight", sans-serif;
  cursor: pointer;
  transition:
    background 0.18s,
    box-shadow 0.18s,
    transform 0.12s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 4px 16px rgba(227, 253, 100, 0.3);
  letter-spacing: -0.01em;
  position: relative;
  overflow: hidden;
  isolation: isolate;
}
.fct-submit::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: -60%;
  width: 50%;
  z-index: -1;
  background:
    linear-gradient(
      105deg,
      transparent 0%,
      rgba(255, 255, 255, 0.65) 50%,
      transparent 100%);
  transform: translateX(0) skewX(-12deg);
  pointer-events: none;
}
.fct-submit:hover:not(:disabled) {
  background: #d9f54a;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 10px 28px -6px rgba(170, 200, 30, 0.55);
  transform: translateY(-1px);
}
.fct-submit:hover:not(:disabled)::after {
  transform: translateX(380%) skewX(-12deg);
  transition: transform 0.75s cubic-bezier(0.16, 1, 0.3, 1);
}
.fct-submit:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px #ffffff, 0 0 0 5px #1d2530;
}
.fct-submit:active:not(:disabled) {
  transform: translateY(0) scale(0.99);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.fct-submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
}
.fct-submit--loading {
  pointer-events: none;
}
.fct-submit__arrow {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  transition: transform 0.18s;
}
.fct-submit:hover .fct-submit__arrow {
  transform: translateX(3px);
}
.fct-dots {
  display: flex;
  align-items: center;
  gap: 5px;
}
.fct-dots span {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  animation: fct-pulse 1.1s ease-in-out infinite;
}
.fct-dots span:nth-child(2) {
  animation-delay: 0.18s;
}
.fct-dots span:nth-child(3) {
  animation-delay: 0.36s;
}
@keyframes fct-pulse {
  0%, 80%, 100% {
    opacity: 0.35;
    transform: scale(0.85);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.fct-form__footer {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #f3f4f6;
  padding-top: 20px;
}
@media (max-width: 860px) {
  .fct-form__footer {
    border-top-color: rgba(255, 255, 255, 0.08);
  }
}
.fct-register {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 5px;
}
@media (max-width: 860px) {
  .fct-register {
    color: rgba(255, 255, 255, 0.38);
  }
}
.fct-support {
  display: flex;
  align-items: center;
  gap: 6px;
}
.fct-support__label {
  font-size: 12px;
  color: #9ca3af;
}
@media (max-width: 860px) {
  .fct-support__label {
    color: rgba(255, 255, 255, 0.25);
  }
}
.fct-login--motion .fct-word {
  opacity: 0;
}
.fct-login--motion .fct-hl__swash path {
  opacity: 0;
}
.fct-login--motion .fct-widget__chart-line,
.fct-login--motion .fct-widget__chart-area,
.fct-login--motion .fct-widget__chart-dot {
  opacity: 0;
}
.fct-login--motion .fct-toast:first-child {
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .fct-aurora__blob {
    animation: none;
  }
  .fct-widget::before {
    animation: none;
  }
  .fct-network,
  .fct-widget-wrap,
  .fct-toasts {
    translate: none;
    transition: none;
  }
  .fct-brand__dots-hi {
    display: none;
  }
  .fct-submit::after {
    display: none;
  }
  .fct-form__orbits {
    animation: none;
  }
}
@keyframes fct-up {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/*# sourceMappingURL=login.component.css.map */
